var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs--container"},[_c('div',{staticClass:"breadcrumbs--block"},_vm._l((_vm.mainData),function(item){return _c('div',{key:item.block,staticClass:"item",class:{active: item.active === true}},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }